import React from 'react';
import Layout from '../../../components/layout';
import MetaData from '../../../components/meta-data';
import Headline from '../../../components/headline';
import Breadcrumbs from '../../../components/breadcrumbs';
var FoodIndex = function FoodIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$mercadito, _props$data$oakAndCha;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Food Photos",
        description: 'Food photography by Drew Templeton.  Food photography was my first found passion in professional photography.  Lots of Chicago food porn in here.',
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement("h1", null, "Food"), /*#__PURE__*/ React.createElement("p", null, "Food photography was my first found passion in professional photography. I started working as a marketing intern for Mercadito Hospitality when I was in graduate school at DePaul and it afforded me some great opportunies to take lots of photos of lots of great food as well as expose me to the hospitality network in the best food city in the world. Here's some shots that I took both on the job, and for the hell of it. As a side note, people really think you take your shit seriously when you couple your reservation with a big ass camera. I kind of wish I could shrink my setup and draw less attention. If you know some tricks,", ' ', /*#__PURE__*/ React.createElement("a", {
        href: "https://instagram.com/drewbie613"
    }, "hit me up")))), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'right',
        image: {
            source: (_props$data$mercadito = props.data.mercaditoHospitality.edges[Math.floor(Math.random() * props.data.mercaditoHospitality.edges.length)].node.childImageSharp) === null || _props$data$mercadito === void 0 ? void 0 : _props$data$mercadito.fluid,
            altText: 'Mercadito Hospitality'
        },
        link: '/photos/food/mercadito-hospitality/',
        copy: {
            headline: {
                h1: 'Mercadito Hospitality'
            },
            text: 'I worked here for a couple of years and took photos of many different restaurant openings.  Mercadito is still 💯'
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$oakAndCha = props.data.oakAndChar.edges[Math.floor(Math.random() * props.data.oakAndChar.edges.length)].node.childImageSharp) === null || _props$data$oakAndCha === void 0 ? void 0 : _props$data$oakAndCha.fluid,
            altText: 'Oak + Char'
        },
        link: '/photos/food/oak-and-char/',
        copy: {
            headline: {
                h1: 'Oak + Char'
            },
            text: 'This place was good, and eating this food after taking the photos was a nice perk.'
        }
    }));
};
export default FoodIndex;
var query = "4253432662";
